import type { TranslateDictionary } from './en.js';

export const Id: TranslateDictionary = {
  'Start airplay': 'Mulai AirPlay',
  'Stop airplay': 'Hentikan AirPlay',
  Audio: 'Audio',
  Captions: 'Takarir',
  'Enable captions': 'Aktifkan takarir',
  'Disable captions': 'Nonaktifkan takarir',
  'Start casting': 'Mulai casting',
  'Stop casting': 'Hentikan casting',
  'Enter fullscreen mode': 'Masuki layar penuh',
  'Exit fullscreen mode': 'Tinggalkan layar penuh',
  Mute: 'Bisu',
  Unmute: 'Bunyikan',
  'Enter picture in picture mode': 'Masuki mode gambar-dalam-gambar',
  'Exit picture in picture mode': 'Keluar dari mode gambar-dalam-gambar',
  Play: 'Putar',
  Pause: 'Jeda',
  'Playback rate': 'Kecepatan pemutaran',
  'Playback rate {playbackRate}': 'Kecepatan pemutaran {playbackRate}',
  Quality: 'Kualitas',
  'Seek backward': 'Mundur',
  'Seek forward': 'Maju',
  Settings: 'Pengaturan',
  Auto: 'Otomatis',
  'audio player': 'pemutar audio',
  'video player': 'pemutar video',
  volume: 'Volume',
  seek: 'Cari',
  'closed captions': 'Takarir',
  'current playback rate': 'kecepatan pemutaran saat ini',
  'playback time': 'waktu pemutaran',
  'media loading': 'memuat media',
  settings: 'Pengaturan',
  'audio tracks': 'trek audio',
  quality: 'Kualitas',
  play: 'putar',
  pause: 'jeda',
  mute: 'bisu',
  unmute: 'bunyikan',
  'chapter: {chapterName}': 'bab: {chapterName}',
  live: 'langsung',
  Off: 'Nonaktif',
  'start airplay': 'mulai AirPlay',
  'stop airplay': 'hentikan AirPlay',
  'start casting': 'mulai casting',
  'stop casting': 'hentikan casting',
  'enter fullscreen mode': 'masuki layar penuh',
  'exit fullscreen mode': 'tinggalkan layar penuh',
  'enter picture in picture mode': 'masuki mode gambar-dalam-gambar',
  'exit picture in picture mode': 'keluar dari mode gambar-dalam-gambar',
  'seek to live': 'ke siaran langsung',
  'playing live': 'memutar langsung',
  'seek back {seekOffset} seconds': 'mundur {seekOffset} detik',
  'seek forward {seekOffset} seconds': 'maju {seekOffset} detik',
  'Network Error': 'Kesalahan Jaringan',
  'Decode Error': 'Kesalahan Decode',
  'Source Not Supported': 'Sumber Tidak Didukung',
  'Encryption Error': 'Kesalahan Enkripsi',
  'A network error caused the media download to fail.':
    'Kesalahan jaringan menyebabkan pengunduhan media gagal.',
  'A media error caused playback to be aborted. The media could be corrupt or your browser does not support this format.':
    'Kesalahan media menyebabkan pemutaran dibatalkan. Media mungkin rusak atau browser Anda tidak mendukung format ini.',
  'An unsupported error occurred. The server or network failed, or your browser does not support this format.':
    'Terjadi kesalahan yang tidak didukung. Server atau jaringan gagal, atau browser Anda tidak mendukung format ini.',
  'The media is encrypted and there are no keys to decrypt it.':
    'Media dienkripsi dan tidak ada kunci untuk mendekripsinya.',
};
